'use client'
import { PrismicImage, PrismicRichText } from "@prismicio/react";
import { useState } from "react";

/**
 * @typedef {import("@prismicio/client").Content.DetailEcoRenovationSlice} DetailEcoRenovationSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<DetailEcoRenovationSlice>} DetailEcoRenovationProps
 * @param {DetailEcoRenovationProps}
 */

const DetailEcoRenovationItem = ({ item, index }) => {

  const [isOpen, setIsOpen] = useState(false);
  function toggle() {
    setIsOpen(!isOpen);
  }

  return <div className={`md:flex md:pt-20 xl:pt-10 ${index % 2 ? 'md:flex-row-reverse' : ''} ${index == 0 ? ' pt-30px xl:pt-10' : ''}`}>
    <div className={`${index % 2 ? 'md:ml-10' : 'md:mr-10'} grow`}>
      <div className="h3-like border-b-2 border-dark-grey pb-5 flex items-center justify-between toggle-btn" onClick={toggle}>
        <PrismicRichText field={item.title} />
        <div className={`spin_arrow md:hidden h-2 w-4 ${isOpen ? 'toggle-active' : ''}`}>
          <img src='/svg/arrow-faq.svg' className="w-full h-auto"  loading={index === 0 ? '' : 'lazy'}/>
        </div>
      </div>
      <div className={`pt-5 pb-6 small md:block ${isOpen ? '' : 'hidden'}`}>
        <PrismicRichText field={item.text} />
      </div>
    </div>
    <div className={`md:block  ${isOpen ? '' : 'hidden'}`}>
      <PrismicImage
        className="w-full h-[50vmin] md:w-[270px] md:h-[270px] max-w-none object-cover"   loading={index === 0 ? '' : 'lazy'}
        field={item.picture} />
    </div>
  </div>
}

const DetailEcoRenovation = ({ slice, index }) => {

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={`bg-${slice.primary.bg_color} bg-grain ${index !== 0 ? 'border-t-2 border-dark-grey' : ''} ${slice.variation == "first" ? '' : '!border-t-0'}`}>
      <div className={`max-w-[1400px] px-4 md:px-7 lg:px-10 md:m-auto ${slice.variation === 'first' ? 'pt-10 md:pt-20 lg:pt-36' : 'pt-8 md:pt-[75px]'}  ${slice.variation === 'last' ? 'pb-12 md:pb-[100px]' : 'pb-10 md:pb-[75px]'}`}>
        <div className={`lg:flex ${slice.primary.is_picture_reversed ? 'lg:flex-row-reverse' : ''} xl:mx-[63px]`}>
          <div className={`${slice.primary.is_picture_reversed ? 'lg:ml-10' : 'lg:mr-10'}`} >
            <div className="h2-like border-b-2 border-dark-grey pb-5">
              <PrismicRichText field={slice.primary.title}

              />
            </div>
            <div className="py-5">
              <PrismicRichText field={slice.primary.text} />
            </div>
          </div>
          <PrismicImage field={slice.primary.picture}
            className={`${slice.primary.is_picture_reversed ? 'rounded-tr-[180px] md:rounded-none' : 'rounded-tl-[180px] md:rounded-none'} border-0 w-screen md:h-[350px] lg:w-[477px] lg:h-[477px] aspect-square object-cover`}  loading={index === 0 ? '' : 'lazy'}/>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-y-[30px] md:gap-x-7 xl:gap-x-10">
          {
            slice.primary.pictures.map((item, i) =>
              <DetailEcoRenovationItem key={i} item={item} index={i} />
            )
          }
        </div>
      </div>
    </section >
  );
};

export default DetailEcoRenovation;
